import { createContext, useContext, useState } from "react";

const NavbarVisibilityContext = createContext();

export function NavbarVisibilityProvider({ children }) {
  const [navbarVisible, setNavbarVisible] = useState(true);
  return (
    <NavbarVisibilityContext.Provider value={{ navbarVisible, setNavbarVisible }}>
      {children}
    </NavbarVisibilityContext.Provider>
  );
}

export function useNavbarVisibility() {
  return useContext(NavbarVisibilityContext);
} 